import React, { Component } from 'react';

// CSS
import './styles.css';

export default class ScheduleTableHead extends Component {
  _renderAlignmentClass = (alignment) => {
    switch (alignment) {
      case 'left': {
        return 'ScheduleTableHead__cell--left';
      }

      case 'right': {
        return 'ScheduleTableHead__cell--right';
      }

      case 'center': {
        return 'ScheduleTableHead__cell--center';
      }

      default: {
        return '';
      }
    }
  }

  render() {
    const { headers } = this.props;

    return (
      <thead className="ScheduleTableHead">
        <tr>
          {
            headers.map((header, index) => (
              <td
                className={`
                  ScheduleTableHead__cell 
                  ${this._renderAlignmentClass(header.alignment)}
                `}
                key={index}
              >
                {header.title}
              </td>
            ))
          }
        </tr>
      </thead>
    );
  }
}
